module.exports = __webpack_public_path__ + "img/spirit_small_6.78e460a1.png";